
export const APP_ROUTES = {
  LOGIN: '/login',
  SIGNUP: '/signup',
  RESET_PASSWORD: '/resetpassword',
  PROXY: '/proxy',
  CALLBACK: '/callback',
  HOME: '/home',
  LOCAL_RA_HOME: '/local-ra',
  GLOBAL_RA_HOME: '/global-ra',
  USER_MANAGEMENT: '/user-management',
  SOFTWARE_MANAGER: '/software-manager',
  CUSTOMER_ONBOARDING: '/customer-onboarding',
  CUSTOMER_LISTING_DETAIL: '/customer-listing/:sno', 
  PRODUCTS_ONBOARDING: '/products-onboarding',
  USER_PROFILE: '/user-profile',
};

// Re-export all constants from a single entry point
 export * from './routes'; 